import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Footer from './Components/Footer.jsx';
import Header from './Components/Header.jsx';
import AdminHeader from './Components/Adminheader.jsx';
import UmpireHeader from './Components/UmpireHeader.jsx';
import Userqr from './Components/Userqr.jsx';

import Home from './Pages/Landing.jsx';
import Tournament from './Pages/tournament.jsx';
import Registration from './Pages/Registration.jsx';
import ExistingUser from './Pages/ExistingUser.jsx';
import Login from './Pages/Login.jsx';
import Userreg from './Pages/Userreg.jsx';
import Events from './Pages/Events.jsx';
import AboutUs from './Pages/AboutUs.jsx';
import ContactUs from './Pages/ContactUs.jsx';
import TournamentSetup from './Pages/Tournamentsetup.jsx';
import AdminDashboard from './Pages/AdminDashboard.jsx';
import Tournamentalldetails from './Pages/Tournamentalldetails.jsx';
import Profile from './Pages/Profile.jsx';
import TournamentList from './Pages/tournament-list.jsx';
import Gamelist from './Pages/Gamelist.jsx';
import Userlist from './Pages/Userlist.jsx';
import Adminprofile from './Pages/Adminprofile.jsx';

// Sponsors Page
import Sponsors from './Pages/sponsors.jsx';

// Umpire Pages
import ListOfGame from './Pages/ListOfGame.jsx';
import MatchScore from './Pages/MatchScore.jsx';
import CompletedMatches from './Pages/CompletedMatches.jsx';

// Court Management Pages
import Court from './Pages/court.jsx';
import Individualcourtscreen from './Pages/Individualcourtscreen.jsx';
import AllCourtsScreen from './Pages/AllCourtsScreen.jsx';
import Court1 from './Pages/Court1Page.jsx';
import Court2 from './Pages/Court2.jsx';
import Court3 from './Pages/court3.jsx';
import Court4 from './Pages/court4.jsx';
import Courtlive from './Pages/courtlive.jsx';

// EVENT CATEGORIES SETUP PAGE
import Eventcategoriessetup from './Pages/Eventcategoriessetup.jsx';

// EVENTTYPE SETUP PAGE
import Eventtypessetup from './Pages/Eventtypessetup.jsx';

// TOURNAMENT DASHBOARD
import Tournamentdashboard from './Pages/Tournamentdashboard.jsx';

// TOURNAMENT SCORE ENTRY
import ScoreEntry from './Pages/Scoreentry.jsx';

// ROUND SETUP CONFIGURATION
import RoundsSetup from './Pages/RoundsSetup.jsx';

// ✅ TOURNAMENT DRAWS - Import default export
import TournamentDraws from './Pages/TournamentDraws.jsx';

// ✅ SPORTS INDEX - Import default export
import SportsIndex from './Pages/SportsIndex.jsx';

//BISHOP MATCH SCHEDULER
import MatchScheduler from './Pages/MatchScheduler';

// Vendor Scanner Page
import VendorScanner from './Pages/VendorScanner.jsx';

function AppContent() {
  const location = useLocation();
  
  const currentPath = location.pathname.toLowerCase();

  // Admin routes - These will show AdminHeader
  const adminRoutes = [
    '/tournament-setup',
    '/admindashboard',
    '/admin/tournament-details',
    '/tournament-list',
    '/userlist',
    '/gamelist',
    '/adminprofile',
    '/sponsors',
    '/eventcategoriessetup',
    '/eventtypessetup',
    '/tournamentdashboard',
    '/score-entry',
    '/rounds-setup',
    '/match-scheduler'
  ];

  // Umpire routes - These will show UmpireHeader
  const umpireRoutes = [
    '/listofgame',
    '/completed-matches',
  ];

  // Routes with no header/footer
  const noHeaderFooterRoutes = [
    '/matchscore', 
    '/court', 
    '/individualcourtscreen', 
    '/allcourts',
    '/vendor-scanner'
  ];

  // Check if current path is an admin route
  const isAdminRoute = adminRoutes.some(route => currentPath === route.toLowerCase());
  const isUmpireRoute = umpireRoutes.some(route => currentPath === route.toLowerCase());
  
  const isNoHeaderFooterRoute = noHeaderFooterRoutes.some(route => 
    currentPath.startsWith(route.toLowerCase())
  );
  
  // Tournament Draws and Sports Index pages should hide footer
  const isTournamentDrawsRoute = currentPath.startsWith('/tournament-draws');
  const isSportsIndexRoute = currentPath.startsWith('/tournament-sports');
  
  const shouldHideFooter = 
    isAdminRoute || 
    isUmpireRoute || 
    currentPath === '/profile' ||
    currentPath === '/login' ||
    isNoHeaderFooterRoute ||
    isTournamentDrawsRoute ||
    isSportsIndexRoute;

  // Determine which header to show
  const renderHeader = () => {
    if (isNoHeaderFooterRoute) return null;
    if (isAdminRoute) return <AdminHeader />;
    if (isUmpireRoute) return <UmpireHeader />;
    return <Header />;
  };

  const renderFooter = () => {
    if (shouldHideFooter) return null;
    return <Footer />;
  };

  return (
    <div className="App">
      <div className="app-container">
        {renderHeader()}

        <main className="main-content">
          <Routes>
            {/* ============================================
                PUBLIC ROUTES
                ============================================ */}
            
            {/* Home/Landing Page */}
            <Route path="/" element={<Home />} />
            
            {/* Tournament & Registration */}
            <Route path="/tournament" element={<Tournament />} />
            <Route path="/existing-user" element={<ExistingUser />} />
            <Route path="/Userreg" element={<Userreg />} />
            <Route path="/login" element={<Login />} />
            <Route path="/registration" element={<Registration />} />
            
            {/* Info Pages */}
            <Route path="/events" element={<Events />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            
            {/* User Profile */}
            <Route path="/profile" element={<Profile />} />
            <Route path="/Userqr" element={<Userqr />} />
            
            {/* ✅ SPORTS INDEX - Shows all sports for a tournament */}
            <Route path="/tournament-sports/:tournamentId" element={<SportsIndex />} />
            
            {/* ✅ TOURNAMENT DRAWS - Shows draws for specific sport */}
            <Route path="/tournament-draws/:tournamentId/:sportId" element={<TournamentDraws />} />
            
            {/* ✅ TOURNAMENT DASHBOARD - Public route */}
            <Route path="/tournament-dashboard/:tournamentId" element={<Tournamentdashboard />} />

            {/* ============================================
                ADMIN ROUTES
                ============================================ */}
            
            <Route path="/tournament-setup" element={<TournamentSetup />} />
            <Route path="/AdminDashboard" element={<AdminDashboard />} />
            <Route path="/admin/tournament-details" element={<Tournamentalldetails />} />
            <Route path="/tournament-list" element={<TournamentList />} />
            <Route path="/Userlist" element={<Userlist />} />
            <Route path="/Gamelist" element={<Gamelist />} />
            <Route path="/Adminprofile" element={<Adminprofile />} />
            <Route path="/Eventcategoriessetup" element={<Eventcategoriessetup />} />
            <Route path="/Eventtypessetup" element={<Eventtypessetup />} />
            <Route path="/tournamentdashboard" element={<Tournamentdashboard />} />
            <Route path="/score-entry" element={<ScoreEntry />} /> 
            <Route path="/rounds-setup" element={<RoundsSetup />} />
            <Route path="/sponsors" element={<Sponsors />} />
            <Route path="/match-scheduler" element={<MatchScheduler />} />

            {/* ============================================
                UMPIRE ROUTES
                ============================================ */}
            
            <Route path="/listofgame" element={<ListOfGame />} />
            <Route path="/matchscore/:id" element={<MatchScore />} />
            <Route path="/completed-matches" element={<CompletedMatches />} />

            {/* ============================================
                COURT ROUTES (No Header/Footer)
                ============================================ */}
            
            <Route path="/court" element={<Court />} />
            <Route path="/individualcourtscreen" element={<Individualcourtscreen />} />
            <Route path="/allcourts" element={<AllCourtsScreen />} />
            <Route path="/court1" element={<Court1 />} />
            <Route path="/court2" element={<Court2 />} />
            <Route path="/court3" element={<Court3 />} />
            <Route path="/court4" element={<Court4 />} />
            <Route path="/courtlive" element={<Courtlive />} />

            {/* ============================================
                VENDOR SCANNER (No Header/Footer)
                ============================================ */}
            
            <Route path="/vendor-scanner" element={<VendorScanner />} />

            {/* ============================================
                404 NOT FOUND
                ============================================ */}
            
            <Route path="*" element={<div>Page Not Found</div>} />
          </Routes>
        </main>

        {renderFooter()}
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;